<template>
    <div
        :class="{ error }"
        class="formGroup"
    >
        <label
            :for="labelFor"
            :class="{'hasFlag': flag}"
            class="label"
        >
            <img
                v-if="flag"
                :src="flagIcon"
                class="flag"
            >
            {{ label }}
        </label>
        <slot/>
        <ValidationMessage
            :required="required"
            :error="error"
            :message="errorMessage"
        />
    </div>
</template>

<script>
import ValidationMessage from './ValidationMessage.vue';
import de from '../../assets/images/flags/de.svg';
import en from '../../assets/images/flags/en.svg';
import fr from '../../assets/images/flags/fr.svg';
import sv from '../../assets/images/flags/sv.svg';
import us from '../../assets/images/flags/us.svg';

export default {
    components: {
        ValidationMessage,
    },
    props: {
        label: {
            type: String,
            default: null,
        },
        labelFor: {
            type: String,
            default: null,
        },
        flag: {
            type: String,
            default: null,
        },
        required: {
            type: Boolean,
            default: false,
        },
        error: {
            type: Boolean,
            default: false,
        },
        errorMessage: {
            type: String,
            default: null,
        },
    },
    computed: {
        flagIcon() {
            const flags = {
                de, en, fr, sv, us,
            };
            return flags[this.flag];
        },
    },
};
</script>

<style lang="postcss" scoped>
.formGroup {
    margin-bottom: 25px;
    &:last-child {
        margin-bottom: 0;
    }
}
.flag {
    height: 14px;
    width: auto;
    margin-right: 8px;
    margin-bottom: 3px;
}
.label {
    display: block;
    margin-bottom: 10px;
    font-weight: 500;
    font-size: 16px;
    @media (--laptop) {
        font-size: 15px;
    }
}
.hasFlag {
    display: flex;
    align-items: center;
}
</style>
